export default function isMobileVersion() {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  return width <= 767;
}
